<template>
    <span v-if="props.numberState === 'none'" data-test="no-number" class="text-slate-500">-</span>
    <div v-else class="flex min-w-0">
        <vx-popover hover teleport arrow placement="top" class="min-w-0">
            <div class="flex min-w-0 items-center gap-2">
                <span v-if="props.phoneNumber !== ''" data-test="phone-number" class="min-w-0 truncate">
                    {{ phoneNumberLabel(props.phoneNumber) }}
                </span>
                <span
                    v-if="otherNumbersCount > 0"
                    data-test="other-numbers"
                    class="shrink-0 whitespace-nowrap text-slate-500"
                >
                    +{{ otherNumbersCount }} more
                </span>
                <template v-if="props.numberState === 'assigned_not_enabled'">
                    <font-awesome-icon widthAuto class="shrink-0 text-amber-500" :icon="faTriangleExclamation" />
                    <span data-test="number-state" class="sr-only">{{ numberStateLabels.assigned_not_enabled }}</span>
                </template>
                <vx-badge
                    v-else-if="props.numberState === 'corporate'"
                    data-test="number-state"
                    color="slate"
                    size="xs"
                    class="shrink-0"
                >
                    {{ numberStateLabels.corporate }}
                    <font-awesome-icon widthAuto :icon="faCrown" />
                </vx-badge>
            </div>
            <template v-slot:content>
                <div data-test="number-explanation" class="max-w-[220px] text-center">
                    <div v-if="props.phoneNumber !== ''" class="font-semibold">
                        {{ phoneNumberLabel(props.phoneNumber) }}
                    </div>
                    <div v-for="line in explanation" :key="line">{{ line }}</div>
                </div>
            </template>
        </vx-popover>
    </div>
</template>

<script lang="ts" setup>
import { faCrown, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBadge, VxPopover } from '@voxie/frontend-components';
import { computed } from 'vue';
import type { KioskTeamGroupNumberState } from '~/services/adminTeamGroupsClient.types';
import { numberStateLabels, phoneNumberLabel } from './kioskTeamGroupsTableHelpers';

const numberStateExplanations: Record<Exclude<KioskTeamGroupNumberState, 'none'>, string[]> = {
    sending: ['Group number used for sending.'],
    assigned_not_enabled: ['Number assigned but not enabled for sending.', 'This group cannot send messages.'],
    corporate: ['Corporate number used for sending.'],
};

const props = defineProps<{
    phoneNumber: string;
    phoneNumbersCount: number;
    numberState: KioskTeamGroupNumberState;
}>();

const explanation = computed(() => (props.numberState === 'none' ? [] : numberStateExplanations[props.numberState]));

const otherNumbersCount = computed(() => (props.phoneNumber === '' ? 0 : Math.max(props.phoneNumbersCount - 1, 0)));
</script>
